
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { db } from '@/plugins/firebase';
import { Entry, Project } from '@/types';

@Component
export default class ProjectsView extends Vue {
  projects: Project[] = [];

  title() {
    return 'プロジェクト一覧';
  }

  async bind() {
    const query = db.collection('projects').where('display', '==', true);
    this.$bind('projects', query);
  }
  async created() {
    this.bind();
  }
}
